// import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
// import PerfectScrollbar from 'react-perfect-scrollbar';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { useTranslation } from 'react-i18next';
// import { Link, useParams } from 'react-router-dom';
// import useGetChartAccountsDetailsList from '@hooks/Finance/useGetChartAccountsDetailsList';
// import { AppSettings } from '@config/app-settings.js';
// import AccountsForm from './AccountsForm';
// import { type ChartAccountsDetailsModels } from '@store/Finance/ChartAccounts/ChartAccountsModels';
// import { Card } from '@components/card/card';
// import Loading from '@components/Shared/Loader/Loading';

// const Index = () => {
//   const [isAdd, setIsAdd] = useState<boolean>(false);
//   const { t, i18n } = useTranslation();
//   const { ChartAccountsId } = useParams();
//   const [TreeDetails, setTreeDetails] = useState<ChartAccountsDetailsModels>();
//   const [breadcrumb, setBreadcrumb] = useState<any>([]);
//   const { ChartAccountsDetailsList: data, loading } = useGetChartAccountsDetailsList();

//   const filteredData = data
//     ?.slice()
//     ?.filter(f => f.id === ChartAccountsId)
//     ?.sort((a, b) => a.sequenceNum - b.sequenceNum);

//   //#region updateBreadcrumb
//   const updateBreadcrumb = (clickedItem: any) => {
//     const findItem = (itemId: string, items: any[]): any => {
//       for (const item of items) {
//         if (item.id === itemId) {
//           return item;
//         }
//         if (item.children) {
//           const found = findItem(itemId, item.children);
//           if (found) {
//             return found;
//           }
//         }
//       }
//       return null;
//     };

//     const findParentItems = (item: any, parents: any[] = []) => {
//       if (item.accountParant) {
//         const parentItem = findItem(item.accountParant, data);
//         if (parentItem) {
//           parents.unshift(parentItem);
//           findParentItems(parentItem, parents);
//         }
//       }
//       return parents;
//     };

//     const clickedItemData = findItem(clickedItem.id, data);

//     if (clickedItemData) {
//       const parents = findParentItems(clickedItemData);
//       const breadcrumbData = parents?.map((parent: any) => ({
//         id: parent.id,
//         name: i18n.language === 'en' ? parent.name : parent.name2,
//         link: null
//       }));

//       breadcrumbData.push({
//         id: clickedItemData.id,
//         name: i18n.language === 'en' ? clickedItemData.name : clickedItemData.name2,
//         link: null
//       });

//       setBreadcrumb(breadcrumbData);
//     }
//   };
//   //#endregion

//   const BcrumbList = [
//     {
//       name: 'Home',
//       link: ':moduleHome'
//     },
//     {
//       name: 'الدليل المحاسبي',
//       link: '/FinanceSettings/ChartAccounts'
//     },
//     {
//       name: 'الحسابات',
//       link: null
//     }
//   ];

//   //#region useContext(AppSettings)
//   const context = useContext(AppSettings);
//   useEffect(() => {
//     const handleFileArrowClick = (event: any) => {
//       event.preventDefault();
//       const node = event.target.closest('.file-node.has-sub');
//       if (node) {
//         node.classList.toggle('expand');
//       }
//     };

//     const handleFileInfoClick = (event: any) => {
//       event.preventDefault();
//       const node = event.target.closest('.file-node');
//       if (node) {
//         const fileInfoNodes = document.querySelectorAll('.file-node');
//         fileInfoNodes.forEach(otherNode => {
//           if (otherNode !== node) {
//             otherNode.classList.remove('selected');
//           }
//         });
//         node.classList.add('expand');
//         node.classList.add('selected');
//       }
//     };

//     const fileHasSubNodes = document.querySelectorAll('.file-node.has-sub');
//     fileHasSubNodes.forEach(node => {
//       const fileArrow = node.querySelector('.file-link > .file-arrow');
//       fileArrow?.addEventListener('click', handleFileArrowClick);
//     });

//     const fileInfoNodes = document.querySelectorAll('.file-node');
//     fileInfoNodes.forEach(node => {
//       const fileInfo = node.querySelector('.file-link > .file-info');
//       fileInfo?.addEventListener('click', handleFileInfoClick);
//     });

//     context.setAppContentFullHeight(true);

//     return function cleanUp() {
//       context.setAppContentFullHeight(false);
//       fileHasSubNodes.forEach(node => {
//         const fileArrow = node.querySelector('.file-link > .file-arrow');
//         fileArrow?.removeEventListener('click', handleFileArrowClick);
//       });
//       fileInfoNodes.forEach(node => {
//         const fileInfo = node.querySelector('.file-link > .file-info');
//         fileInfo?.removeEventListener('click', handleFileInfoClick);
//       });
//     };
//   }, [data, context]);
//   //#endregion

//   return (
//     <>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb BreadcrumbList={BcrumbList} PageName='الحسابات' />
//       </div>

//       <Card className='mb-4'>
//         <div className='card-header d-flex justify-content-between align-items-center'>
//           <h6 className='mb-0'>
//             <i className='fas fa-sitemap me-2'></i>
//             الشجرة المحاسبية
//             <span className='badge bg-primary ms-2'>الدليل المحاسبي</span>
//           </h6>
//           <div>
//             <span className='badge bg-theme me-2'>إجمالي الحسابات: {data?.length || 0}</span>
//             <span className='badge bg-success'>المستوى: {TreeDetails?.accountlevel || '-'}</span>
//           </div>
//         </div>

//         <div className='card-body p-0'>
//           <Loading loading={loading} error={null} Type='Dots'>
//             <div className='row p-3'>
//               <div className='col-lg-5'>
//                 <Card className='h-100 border-0 '>
//                   <div className='card-header bg-theme bg-opacity-10 border-theme'>
//                     <h6 className='m-0 text-theme'>
//                       <i className='fas fa-tree me-2'></i>
//                       هيكل الحسابات
//                     </h6>
//                   </div>
//                   <div className='card-body p-0'>
//                     {/* <PerfectScrollbar className='h-100 p-2' style={{ maxHeight: '600px' }}>
//                       <div className='file-tree'>
//                         {filteredData?.map((tree, idx) => {
//                           return (
//                             <ItemTree
//                               key={tree.id}
//                               tree={tree}
//                               setTreeDetails={setTreeDetails}
//                               updateBreadcrumb={updateBreadcrumb}
//                               setIsAdd={setIsAdd}
//                             />
//                           );
//                         })}
//                       </div>
//                     </PerfectScrollbar> */}
//                     <PerfectScrollbar
//                       className='file-tree-scroll p-2'
//                       // options={{ suppressScrollX: true, wheelPropagation: false }}
//                     >
//                       <div className='file-tree'>
//                         {filteredData?.map(tree => (
//                           <ItemTree
//                             key={tree.id}
//                             tree={tree}
//                             setTreeDetails={setTreeDetails}
//                             updateBreadcrumb={updateBreadcrumb}
//                             setIsAdd={setIsAdd}
//                           />
//                         ))}
//                       </div>
//                     </PerfectScrollbar>
//                   </div>
//                 </Card>
//               </div>

//               <div className='col-lg-7'>
//                 {TreeDetails?.accountType === 'Accounts' && TreeDetails.accountParant !== null && (
//                   <AccountsForm treeDetails={TreeDetails} breadcrumb={breadcrumb} isAdd={isAdd} />
//                 )}
//                 {(!TreeDetails || TreeDetails.accountParant === null) && (
//                   <Card className='h-100 border-secondary'>
//                     <div className='card-body d-flex align-items-center justify-content-center text-muted'>
//                       <div className='text-center'>
//                         <i className='fas fa-folder-open fa-3x mb-3'></i>
//                         <h6>اختر حساباً من الشجرة لعرض التفاصيل</h6>
//                         <small>انقر على أي حساب في الشجرة لرؤية معلوماته</small>
//                       </div>
//                     </div>
//                   </Card>
//                 )}
//               </div>
//             </div>
//           </Loading>
//         </div>

//         <div className='card-footer d-flex justify-content-between align-items-center'>
//           <div className='text-muted small'>
//             الحساب المحدد: {TreeDetails ? (i18n.language === 'ar' ? TreeDetails.name2 : TreeDetails.name) : 'لا يوجد'}
//           </div>
//           <div className='d-flex gap-3'>
//             <span className='text-theme fw-bold'>رقم الحساب: {TreeDetails?.accountNumber || '-'}</span>
//             <span className='text-success fw-bold'>المستوى: {TreeDetails?.accountlevel || '-'}</span>
//             <span className={`fw-bold ${TreeDetails?.enabledFlag ? 'text-success' : 'text-danger'}`}>
//               {TreeDetails?.enabledFlag ? 'نشط' : 'غير نشط'}
//             </span>
//           </div>
//         </div>
//       </Card>

//       <style>
//         {`
//            height: 600px;  
//             overflow: hidden; 
//             min-height: 0; 
//           `}
//       </style>
//     </>
//   );
// };
// export default Index;

// //

// type PropsItemTree = {
//   tree: any;
//   setTreeDetails: any;
//   updateBreadcrumb: (item: any) => void;
//   setIsAdd: React.Dispatch<React.SetStateAction<boolean>>;
// };

// const ItemTree: React.FC<PropsItemTree> = ({ tree, setTreeDetails, updateBreadcrumb, setIsAdd }) => {
//   const { ChartAccountsDetailsList: data } = useGetChartAccountsDetailsList();
//   const { i18n } = useTranslation();
//   const linkRef = useRef<HTMLAnchorElement | null>(null);

//   return (
//     <Fragment key={tree.id}>
//       <div className='d-flex justify-content-between p-1 border-1 border-start border-theme '>
//         <div
//           className={`file-node ${data?.filter(f => f.accountParant === tree?.id)?.length && 'has-sub'} ${
//             tree?.accountParant === null ? 'expand' : ''
//           }`}
//         >
//           <Link to='' className='file-link'>
//             <span className='file-arrow'></span>
//             <span
//               ref={linkRef}
//               className='file-info'
//               onClick={() => {
//                 setTreeDetails(tree);
//                 updateBreadcrumb(tree);
//                 setIsAdd(false);
//               }}
//             >
//               <span className='file-icon'>
//                 <i className={`bi ${tree.accountlevel === 1 ? 'bi-diagram-3' : 'bi-wallet2'} fa-lg text-theme`}></i>
//               </span>
//               <span className='file-text fs-5 fw-bold'>{i18n.language === 'en' ? tree.name : tree.name2}</span>
//               {/* <span className='file-badge badge bg-secondary ms-2'>{tree.accountNumber}</span> */}
//             </span>
//           </Link>

//           <div className='file-tree'>
//             {data
//               ?.filter((node: any) => node.accountParant === tree.id)
//               ?.sort((a, b) => a.sequenceNum - b.sequenceNum)
//               ?.map((node, idx) => {
//                 return (
//                   <ItemTree
//                     key={node.id}
//                     tree={node}
//                     setTreeDetails={setTreeDetails}
//                     updateBreadcrumb={updateBreadcrumb}
//                     setIsAdd={setIsAdd}
//                   />
//                 );
//               })}
//           </div>
//         </div>
//         <div>
//           <Link
//             to=''
//             hidden={tree.accountlevel === 4 || tree.accountlevel === null}
//             className='pt-1 ms-2 text-theme'
//             onClick={() => {
//               linkRef?.current?.click();
//               setIsAdd(true);
//             }}
//           >
//             <i className='fa-lg fa-fw fs-4 bi bi-plus-square-fill'></i>
//           </Link>
//         </div>
//       </div>
//     </Fragment>
//   );
// };
// _______________________________________________________________________________________________
// _______________________________________________________________________________________________
// _______________________________________________________________________________________________
// _______________________________________________________________________________________________
// _______________________________________________________________________________________________
// _______________________________________________________________________________________________
// _______________________________________________________________________________________________
// _______________________________________________________________________________________________
// _______________________________________________________________________________________________
// _______________________________________________________________________________________________

// import React, { Fragment, useContext, useEffect, useMemo, useRef, useState } from 'react';
// import PerfectScrollbar from 'react-perfect-scrollbar';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { useTranslation } from 'react-i18next';
// import { Link, useParams } from 'react-router-dom';
// import useGetChartAccountsDetailsList from '@hooks/Finance/useGetChartAccountsDetailsList';
// import { AppSettings } from '@config/app-settings.js';
// import AccountsForm from './AccountsForm';
// import { type ChartDetiles } from '@store/Finance/ChartAccounts/ChartAccountsModels';
// import { Card } from '@components/card/card';
// import Loading from '@components/Shared/Loader/Loading';

// type ChartConfig = {
//   maxLevel?: number;
//   level2?: number | null;
//   level3?: number | null;
//   level4?: number | null;
//   level5?: number | null;
//   level6?: number | null;
//   level7?: number | null;
// };

// const Index = () => {
//   const [isAdd, setIsAdd] = useState<boolean>(false);
//   const { t, i18n } = useTranslation();
//   const { ChartAccountsId } = useParams();
//   const [TreeDetails, setTreeDetails] = useState<ChartDetiles>();
//   const [breadcrumb, setBreadcrumb] = useState<any>([]);

//   // ✅ نفس hook لكن نقرأ منه config لو موجود
//   const hook = useGetChartAccountsDetailsList();
//   const { ChartAccountsDetailsList: data, loading } = hook;


  

//   console.log(hook?.ChartConfig);
//   // console.log(hook);
  
   

//   // حاول التقط الكونفج من أي اسم يرجعه عندك
//   const rawConfig: ChartConfig | null = hook?.ChartConfig ?? hook?.Chart ?? null;

//   const chartConfig: Required<ChartConfig> = useMemo(() => {
//     const maxLevel = Number(rawConfig?.maxLevel ?? 4);

//     // Defaults (نفس المنطق القديم 1+2+2+3 = 8) لو الكونفج غير متوفر
//     const def: any = { level2: 2, level3: 2, level4: 3, level5: 2, level6: 2, level7: 2 };

//     return {
//       maxLevel: Number.isFinite(maxLevel) ? maxLevel : 4,
//       level2: (rawConfig?.level2 ?? def.level2) as any,
//       level3: (rawConfig?.level3 ?? def.level3) as any,
//       level4: (rawConfig?.level4 ?? def.level4) as any,
//       level5: (rawConfig?.level5 ?? null) as any,
//       level6: (rawConfig?.level6 ?? null) as any,
//       level7: (rawConfig?.level7 ?? null) as any
//     };
//   }, [rawConfig]);

//   const maxLevel = useMemo(() => Number(chartConfig?.maxLevel ?? 4), [chartConfig]);

//   const filteredData = data
//     ?.slice()
//     ?.filter((f: any) => f.id === ChartAccountsId)
//     ?.sort((a: any, b: any) => a.sequenceNum - b.sequenceNum);

//   //#region updateBreadcrumb
//   const updateBreadcrumb = (clickedItem: any) => {
//     const findItem = (itemId: string, items: any[]): any => {
//       for (const item of items) {
//         if (item.id === itemId) return item;
//         if (item.children) {
//           const found = findItem(itemId, item.children);
//           if (found) return found;
//         }
//       }
//       return null;
//     };

//     const findParentItems = (item: any, parents: any[] = []) => {
//       if (item.accountParant) {
//         const parentItem = findItem(item.accountParant, data);
//         if (parentItem) {
//           parents.unshift(parentItem);
//           findParentItems(parentItem, parents);
//         }
//       }
//       return parents;
//     };

//     const clickedItemData = findItem(clickedItem.id, data);

//     if (clickedItemData) {
//       const parents = findParentItems(clickedItemData);
//       const breadcrumbData = parents?.map((parent: any) => ({
//         id: parent.id,
//         name: i18n.language === 'en' ? parent.name : parent.name2,
//         link: null
//       }));

//       breadcrumbData.push({
//         id: clickedItemData.id,
//         name: i18n.language === 'en' ? clickedItemData.name : clickedItemData.name2,
//         link: null
//       });

//       setBreadcrumb(breadcrumbData);
//     }
//   };
//   //#endregion

//   const BcrumbList = [
//     { name: 'Home', link: ':moduleHome' },
//     { name: 'الدليل المحاسبي', link: '/FinanceSettings/ChartAccounts' },
//     { name: 'الحسابات', link: null }
//   ];

//   //#region useContext(AppSettings)
//   const context = useContext(AppSettings);
//   useEffect(() => {
//     const handleFileArrowClick = (event: any) => {
//       event.preventDefault();
//       const node = event.target.closest('.file-node.has-sub');
//       if (node) node.classList.toggle('expand');
//     };

//     const handleFileInfoClick = (event: any) => {
//       event.preventDefault();
//       const node = event.target.closest('.file-node');
//       if (node) {
//         const fileInfoNodes = document.querySelectorAll('.file-node');
//         fileInfoNodes.forEach(otherNode => {
//           if (otherNode !== node) otherNode.classList.remove('selected');
//         });
//         node.classList.add('expand');
//         node.classList.add('selected');
//       }
//     };

//     const fileHasSubNodes = document.querySelectorAll('.file-node.has-sub');
//     fileHasSubNodes.forEach(node => {
//       const fileArrow = node.querySelector('.file-link > .file-arrow');
//       fileArrow?.addEventListener('click', handleFileArrowClick);
//     });

//     const fileInfoNodes = document.querySelectorAll('.file-node');
//     fileInfoNodes.forEach(node => {
//       const fileInfo = node.querySelector('.file-link > .file-info');
//       fileInfo?.addEventListener('click', handleFileInfoClick);
//     });

//     context.setAppContentFullHeight(true);

//     return function cleanUp() {
//       context.setAppContentFullHeight(false);
//       fileHasSubNodes.forEach(node => {
//         const fileArrow = node.querySelector('.file-link > .file-arrow');
//         fileArrow?.removeEventListener('click', handleFileArrowClick);
//       });
//       fileInfoNodes.forEach(node => {
//         const fileInfo = node.querySelector('.file-link > .file-info');
//         fileInfo?.removeEventListener('click', handleFileInfoClick);
//       });
//     };
//   }, [data, context]);
//   //#endregion

//   return (
//     <>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb BreadcrumbList={BcrumbList} PageName='الحسابات' />
//       </div>

//       <Card className='mb-4'>
//         <div className='card-header d-flex justify-content-between align-items-center'>
//           <h6 className='mb-0'>
//             <i className='fas fa-sitemap me-2'></i>
//             الشجرة المحاسبية
//             <span className='badge bg-primary ms-2'>الدليل المحاسبي</span>
//           </h6>
//           <div>
//             <span className='badge bg-theme me-2'>إجمالي الحسابات: {data?.length || 0}</span>
//             <span className='badge bg-success me-2'>المستوى: {TreeDetails?.accountlevel || '-'}</span>
//             <span className='badge bg-secondary'>MaxLevel: {maxLevel}</span>
//           </div>
//         </div>

//         <div className='card-body p-0'>
//           <Loading loading={loading} error={null} Type='Dots'>
//             <div className='row p-3'>
//               <div className='col-lg-5'>
//                 <Card className='h-100 border-0 '>
//                   <div className='card-header bg-theme bg-opacity-10 border-theme'>
//                     <h6 className='m-0 text-theme'>
//                       <i className='fas fa-tree me-2'></i>
//                       هيكل الحسابات
//                     </h6>
//                   </div>

//                   <div className='card-body p-0'>
//                     <PerfectScrollbar className='file-tree-scroll p-2'>
//                       <div className='file-tree'>
//                         {filteredData?.map((tree: any) => (
//                           <ItemTree
//                             key={tree.id}
//                             tree={tree}
//                             setTreeDetails={setTreeDetails}
//                             updateBreadcrumb={updateBreadcrumb}
//                             setIsAdd={setIsAdd}
//                             maxLevel={maxLevel}
//                           />
//                         ))}
//                       </div>
//                     </PerfectScrollbar>
//                   </div>
//                 </Card>
//               </div>

//               <div className='col-lg-7'>
//                 {TreeDetails?.accountType === 'Accounts' && TreeDetails.accountParant !== null && (
//                   <AccountsForm    
//                     treeDetails={TreeDetails as any}
//                     breadcrumb={breadcrumb}
//                     isAdd={isAdd}
//                     chartConfig={chartConfig}
//                   />
//                 )}

//                 {(!TreeDetails || TreeDetails.accountParant === null) && (
//                   <Card className='h-100 border-secondary'>
//                     <div className='card-body d-flex align-items-center justify-content-center text-muted'>
//                       <div className='text-center'>
//                         <i className='fas fa-folder-open fa-3x mb-3'></i>
//                         <h6>اختر حساباً من الشجرة لعرض التفاصيل</h6>
//                         <small>انقر على أي حساب في الشجرة لرؤية معلوماته</small>
//                       </div>
//                     </div>
//                   </Card>
//                 )}
//               </div>
//             </div>
//           </Loading>
//         </div>

//         <div className='card-footer d-flex justify-content-between align-items-center'>
//           <div className='text-muted small'>
//             الحساب المحدد: {TreeDetails ? (i18n.language === 'ar' ? TreeDetails.name2 : TreeDetails.name) : 'لا يوجد'}
//           </div>
//           <div className='d-flex gap-3'>
//             <span className='text-theme fw-bold'>رقم الحساب: {TreeDetails?.accountNumber || '-'}</span>
//             <span className='text-success fw-bold'>المستوى: {TreeDetails?.accountlevel || '-'}</span>
//             <span className={`fw-bold ${TreeDetails?.enabledFlag ? 'text-success' : 'text-danger'}`}>
//               {TreeDetails?.enabledFlag ? 'نشط' : 'غير نشط'}
//             </span>
//           </div>
//         </div>
//       </Card>

//       <style>
//         {`
//            height: 600px;  
//             overflow: hidden; 
//             min-height: 0; 
//           `}
//       </style>
//     </>
//   );
// };
// export default Index;

// //_______________________________________________________________________________________________

// type PropsItemTree = {
//   tree: any;
//   setTreeDetails: any;
//   updateBreadcrumb: (item: any) => void;
//   setIsAdd: React.Dispatch<React.SetStateAction<boolean>>;
//   maxLevel: number;
// };

// const ItemTree: React.FC<PropsItemTree> = ({ tree, setTreeDetails, updateBreadcrumb, setIsAdd, maxLevel }) => {
//   const { ChartAccountsDetailsList: data } = useGetChartAccountsDetailsList();
//   const { i18n } = useTranslation();
//   const linkRef = useRef<HTMLAnchorElement | null>(null);

//   return (
//     <Fragment key={tree.id}>
//       <div className='d-flex justify-content-between p-1 border-1 border-start border-theme '>
//         <div
//           className={`file-node ${data?.filter((f: any) => f.accountParant === tree?.id)?.length && 'has-sub'} ${
//             tree?.accountParant === null ? 'expand' : ''
//           }`}
//         >
//           <Link to='' className='file-link'>
//             <span className='file-arrow'></span>
//             <span
//               ref={linkRef}
//               className='file-info'
//               onClick={() => {
//                 setTreeDetails(tree);
//                 updateBreadcrumb(tree);
//                 setIsAdd(false);
//               }}
//             >
//               <span className='file-icon'>
//                 <i className={`bi ${tree.accountlevel === 1 ? 'bi-diagram-3' : 'bi-wallet2'} fa-lg text-theme`}></i>
//               </span>
//               <span className='file-text  fw-bold'>{i18n.language === 'en' ? tree.name : tree.name2}</span>
//             </span>
//           </Link>

//           <div className='file-tree'>
//             {data
//               ?.filter((node: any) => node.accountParant === tree.id)
//               ?.sort((a: any, b: any) => a.sequenceNum - b.sequenceNum)
//               ?.map((node: any) => (
//                 <ItemTree
//                   key={node.id}
//                   tree={node}
//                   setTreeDetails={setTreeDetails}
//                   updateBreadcrumb={updateBreadcrumb}
//                   setIsAdd={setIsAdd}
//                   maxLevel={maxLevel}
//                 />
//               ))}
//           </div>
//         </div>

//         <div>
//           <Link
//             to=''
//             hidden={tree.accountlevel == null || Number(tree.accountlevel) >= Number(maxLevel)}
//             className='pt-1 ms-2 text-theme'
//             onClick={() => {
//               linkRef?.current?.click();
//               setIsAdd(true);
//             }}
//           >
//             <i className='fa-lg fa-fw fs-4 bi bi-plus-square-fill'></i>
//           </Link>
//         </div>
//       </div>
//     </Fragment>
//   );
// };



import React, { Fragment, useContext, useEffect, useMemo, useRef, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import useGetChartAccountsDetailsList from '@hooks/Finance/useGetChartAccountsDetailsList';
import { AppSettings } from '@config/app-settings.js';
import AccountsForm from './AccountsForm';
import { type ChartDetiles } from '@store/Finance/ChartAccounts/ChartAccountsModels';
import { Card } from '@components/card/card';
import Loading from '@components/Shared/Loader/Loading';

type ChartConfig = {
  maxLevel?: number;
  level2?: number | null;
  level3?: number | null;
  level4?: number | null;
  level5?: number | null;
  level6?: number | null;
  level7?: number | null;
};

// ------------------------------
// Helpers (Search + Highlight)
// ------------------------------
const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const tokenize = (q: string) =>
  q
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);

const nodeHaystack = (n: any) => {
  const parts = [
    n?.accountNumber ?? '',
    n?.name ?? '',
    n?.name2 ?? '',
    n?.code ?? ''
  ];
  return parts.join(' ').toLowerCase();
};

const matchesTokens = (n: any, tokens: string[]) => {
  if (!tokens.length) return true;
  const hay = nodeHaystack(n);
  return tokens.every(tok => hay.includes(tok));
};

const highlightTokens = (text: string, tokens: string[]) => {
  if (!text || !tokens.length) return text;

  // Highlight each token (OR)
  const pattern = tokens.map(escapeRegExp).join('|');
  const re = new RegExp(`(${pattern})`, 'ig');
  const parts = text.split(re);

  return (
    <>
      {parts.map((p, idx) => {
        const isHit = tokens.some(t => p.toLowerCase() === t.toLowerCase());
        return isHit ? (
          <mark key={idx} className="px-1 rounded">
            {p}
          </mark>
        ) : (
          <Fragment key={idx}>{p}</Fragment>
        );
      })}
    </>
  );
};

const Index = () => {
  const [isAdd, setIsAdd] = useState<boolean>(false);
  const { t, i18n } = useTranslation();
  const { ChartAccountsId } = useParams();

  const [TreeDetails, setTreeDetails] = useState<ChartDetiles>();
  const [breadcrumb, setBreadcrumb] = useState<any>([]);

  // ✅ Search UI State
  const [searchText, setSearchText] = useState<string>('');

  // ✅ Expand/Collapse State (React-driven)
  const [expandedIds, setExpandedIds] = useState<Set<string>>(new Set());
  const [collapsedIdsDuringSearch, setCollapsedIdsDuringSearch] = useState<Set<string>>(new Set());
  const [selectedId, setSelectedId] = useState<string | null>(null);

  // ✅ نفس hook لكن نقرأ منه config لو موجود
  const hook = useGetChartAccountsDetailsList();
  const { ChartAccountsDetailsList: data, loading } = hook;

  const rawConfig: ChartConfig | null = hook?.ChartConfig ?? (hook as any)?.Chart ?? null;

  const chartConfig: Required<ChartConfig> = useMemo(() => {
    const maxLevel = Number(rawConfig?.maxLevel ?? 4);
    const def: any = { level2: 2, level3: 2, level4: 3, level5: 2, level6: 2, level7: 2 };

    return {
      maxLevel: Number.isFinite(maxLevel) ? maxLevel : 4,
      level2: (rawConfig?.level2 ?? def.level2) as any,
      level3: (rawConfig?.level3 ?? def.level3) as any,
      level4: (rawConfig?.level4 ?? def.level4) as any,
      level5: (rawConfig?.level5 ?? null) as any,
      level6: (rawConfig?.level6 ?? null) as any,
      level7: (rawConfig?.level7 ?? null) as any
    };
  }, [rawConfig]);

  const maxLevel = useMemo(() => Number(chartConfig?.maxLevel ?? 4), [chartConfig]);

  // ✅ Roots (كما كنت تعمل: جذر واحد = ChartAccountsId)
  const roots = useMemo(() => {
    return (data ?? [])
      .filter((f: any) => f.id === ChartAccountsId)
      .slice()
      .sort((a: any, b: any) => a.sequenceNum - b.sequenceNum);
  }, [data, ChartAccountsId]);

  // ✅ children map for fast traversal
  const childrenMap = useMemo(() => {
    const map = new Map<string, any[]>();
    (data ?? []).forEach((n: any) => {
      if (!n?.accountParant) return;
      const arr = map.get(n.accountParant) ?? [];
      arr.push(n);
      map.set(n.accountParant, arr);
    });
    // sort children
    for (const [k, arr] of map.entries()) {
      arr.sort((a, b) => (a.sequenceNum ?? 0) - (b.sequenceNum ?? 0));
      map.set(k, arr);
    }
    return map;
  }, [data]);

  const baseGetChildren = (id: string) => childrenMap.get(id) ?? [];

  // ✅ Tokens for search
  const searchTokens = useMemo(() => tokenize(searchText), [searchText]);

  // ✅ Build filtered tree map + auto expand ids
  const searchResult = useMemo(() => {
    // no search => return as-is
    if (!searchTokens.length) {
      return {
        filteredRoots: roots,
        filteredChildrenMap: childrenMap,
        autoExpandIds: new Set<string>(),
        matchIds: new Set<string>(),
        matchCount: 0
      };
    }

    const filteredChildrenMap = new Map<string, any[]>();
    const autoExpandIds = new Set<string>();
    const matchIds = new Set<string>();
    let matchCount = 0;

    const visit = (node: any): boolean => {
      const kids = baseGetChildren(node.id);
      const keptKids: any[] = [];

      let anyChildKept = false;
      for (const k of kids) {
        const keepChild = visit(k);
        if (keepChild) {
          keptKids.push(k);
          anyChildKept = true;
        }
      }

      const isMatch = matchesTokens(node, searchTokens);
      if (isMatch) {
        matchIds.add(node.id);
        matchCount += 1;
      }

      const keep = isMatch || anyChildKept;
      if (keep) {
        filteredChildrenMap.set(node.id, keptKids);
        if (anyChildKept) autoExpandIds.add(node.id); // open parents
      }

      return keep;
    };

    const filteredRoots: any[] = [];
    for (const r of roots) {
      if (visit(r)) filteredRoots.push(r);
    }

    return { filteredRoots, filteredChildrenMap, autoExpandIds, matchIds, matchCount };
  }, [searchTokens, roots, childrenMap]); // eslint-disable-line

  const getChildren = (id: string) => {
    // if searching: children come from filtered map, else full
    if (searchTokens.length) return searchResult.filteredChildrenMap.get(id) ?? [];
    return baseGetChildren(id);
  };

  // ✅ Effective expanded ids:
  const effectiveExpandedIds = useMemo(() => {
    const eff = new Set<string>();

    // always expand roots
    roots.forEach(r => eff.add(r.id));

    if (!searchTokens.length) {
      expandedIds.forEach(id => eff.add(id));
      return eff;
    }

    // during search: expand auto paths, but allow user collapse
    searchResult.autoExpandIds.forEach(id => eff.add(id));

    // if user expanded extra nodes
    expandedIds.forEach(id => eff.add(id));

    // allow collapse overrides during search
    collapsedIdsDuringSearch.forEach(id => eff.delete(id));

    return eff;
  }, [roots, expandedIds, searchTokens.length, searchResult.autoExpandIds, collapsedIdsDuringSearch]);

  // clear "collapsed during search" when search ends
  useEffect(() => {
    if (!searchTokens.length && collapsedIdsDuringSearch.size) {
      setCollapsedIdsDuringSearch(new Set());
    }
  }, [searchTokens.length]); // eslint-disable-line

  const toggleExpand = (id: string) => {
    if (searchTokens.length) {
      // during search: toggle collapse override
      setCollapsedIdsDuringSearch(prev => {
        const next = new Set(prev);
        if (effectiveExpandedIds.has(id)) next.add(id);
        else next.delete(id);
        return next;
      });
      return;
    }

    setExpandedIds(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  //#region updateBreadcrumb
  const updateBreadcrumb = (clickedItem: any) => {
    const findItem = (itemId: string, items: any[]): any => {
      for (const item of items) {
        if (item.id === itemId) return item;
        const kids = baseGetChildren(item.id);
        if (kids?.length) {
          const found = findItem(itemId, kids);
          if (found) return found;
        }
      }
      return null;
    };

    const findParentItems = (item: any, parents: any[] = []) => {
      if (item.accountParant) {
        const parentItem = (data ?? []).find((x: any) => x.id === item.accountParant);
        if (parentItem) {
          parents.unshift(parentItem);
          findParentItems(parentItem, parents);
        }
      }
      return parents;
    };

    const clickedItemData = (data ?? []).find((x: any) => x.id === clickedItem.id);

    if (clickedItemData) {
      const parents = findParentItems(clickedItemData);
      const breadcrumbData = parents?.map((parent: any) => ({
        id: parent.id,
        name: i18n.language === 'en' ? parent.name : parent.name2,
        link: null
      }));

      breadcrumbData.push({
        id: clickedItemData.id,
        name: i18n.language === 'en' ? clickedItemData.name : clickedItemData.name2,
        link: null
      });

      setBreadcrumb(breadcrumbData);
    }
  };
  //#endregion

  const BcrumbList = [
    { name: 'Home', link: ':moduleHome' },
    { name: 'الدليل المحاسبي', link: '/FinanceSettings/ChartAccounts' },
    { name: 'الحسابات', link: null }
  ];

  //#region useContext(AppSettings)
  const context = useContext(AppSettings);
  useEffect(() => {
    context.setAppContentFullHeight(true);
    return () => context.setAppContentFullHeight(false);
  }, [context]);
  //#endregion

  const selectNode = (node: any, addMode: boolean) => {
    setTreeDetails(node);
    updateBreadcrumb(node);
    setIsAdd(addMode);
    setSelectedId(node.id);
  };

  return (
    <>
      <div className="d-flex align-items-center">
        <Breadcrumb BreadcrumbList={BcrumbList} PageName="الحسابات" />
      </div>

      <Card className="mb-4">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h6 className="mb-0">
            <i className="fas fa-sitemap me-2"></i>
            الشجرة المحاسبية
            <span className="badge bg-primary ms-2">الدليل المحاسبي</span>
          </h6>
          <div>
            <span className="badge bg-theme me-2">إجمالي الحسابات: {data?.length || 0}</span>
            <span className="badge bg-success me-2">المستوى: {TreeDetails?.accountlevel || '-'}</span>
            <span className="badge bg-secondary">MaxLevel: {maxLevel}</span>
          </div>
        </div>

        <div className="card-body p-0">
          <Loading loading={loading} error={null} Type="Dots">
            <div className="row p-3">
              <div className="col-lg-5">
                <Card className="h-100 border-0 ">
                  <div className="card-header bg-theme bg-opacity-10 border-theme">
                    <h6 className="m-0 text-theme">
                      <i className="fas fa-tree me-2"></i>
                      هيكل الحسابات
                    </h6>
                  </div>

                  {/* ✅ Search Field */}
                  <div className="p-2 border-bottom">
                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="bi bi-search"></i>
                      </span>
                      <input
                        value={searchText}
                        onChange={e => setSearchText(e.target.value)}
                        className="form-control"
                        placeholder="بحث بالاسم / رقم الحساب..."
                      />
                      {searchText?.trim() && (
                        <button className="btn btn-outline-secondary" onClick={() => setSearchText('')}>
                          <i className="bi bi-x-lg"></i>
                        </button>
                      )}
                    </div>

                    {searchTokens.length ? (
                      <div className="d-flex justify-content-between mt-1">
                        <small className="text-muted">
                          نتائج مطابقة: <b>{searchResult.matchCount}</b>
                        </small>
                        <small className="text-muted">
                          اكتب جزء من الاسم أو رقم الحساب
                        </small>
                      </div>
                    ) : null}
                  </div>

                  <div className="card-body p-0">
                    <PerfectScrollbar className="file-tree-scroll p-2">
                      <div className="file-tree">
                        {searchResult.filteredRoots?.map((tree: any) => (
                          <ItemTree
                            key={tree.id}
                            tree={tree}
                            getChildren={getChildren}
                            expandedIds={effectiveExpandedIds}
                            toggleExpand={toggleExpand}
                            selectedId={selectedId}
                            onSelect={selectNode}
                            setIsAdd={setIsAdd}
                            maxLevel={maxLevel}
                            searchTokens={searchTokens}
                            matchIds={searchResult.matchIds}
                          />
                        ))}

                        {/* no results */}
                        {searchTokens.length && searchResult.filteredRoots?.length === 0 && (
                          <div className="text-muted p-3 text-center">
                            <i className="bi bi-emoji-frown fs-3 d-block mb-2"></i>
                            لا توجد نتائج مطابقة
                          </div>
                        )}
                      </div>
                    </PerfectScrollbar>
                  </div>
                </Card>
              </div>

              <div className="col-lg-7">
                {TreeDetails?.accountType === 'Accounts' && TreeDetails.accountParant !== null && (
                  <AccountsForm
                    treeDetails={TreeDetails as any}
                    breadcrumb={breadcrumb}
                    isAdd={isAdd}
                    chartConfig={chartConfig}
                  />
                )}

                {(!TreeDetails || TreeDetails.accountParant === null) && (
                  <Card className="h-100 border-secondary">
                    <div className="card-body d-flex align-items-center justify-content-center text-muted">
                      <div className="text-center">
                        <i className="fas fa-folder-open fa-3x mb-3"></i>
                        <h6>اختر حساباً من الشجرة لعرض التفاصيل</h6>
                        <small>انقر على أي حساب في الشجرة لرؤية معلوماته</small>
                      </div>
                    </div>
                  </Card>
                )}
              </div>
            </div>
          </Loading>
        </div>

        <div className="card-footer d-flex justify-content-between align-items-center">
          <div className="text-muted small">
            الحساب المحدد: {TreeDetails ? (i18n.language === 'ar' ? (TreeDetails as any).name2 : (TreeDetails as any).name) : 'لا يوجد'}
          </div>
          <div className="d-flex gap-3">
            <span className="text-theme fw-bold">رقم الحساب: {(TreeDetails as any)?.accountNumber || '-'}</span>
            <span className="text-success fw-bold">المستوى: {(TreeDetails as any)?.accountlevel || '-'}</span>
            <span className={`fw-bold ${(TreeDetails as any)?.enabledFlag ? 'text-success' : 'text-danger'}`}>
              {(TreeDetails as any)?.enabledFlag ? 'نشط' : 'غير نشط'}
            </span>
          </div>
        </div>
      </Card>

      <style>
        {`
          height: 600px;
          overflow: hidden;
          min-height: 0;
        `}
      </style>
    </>
  );
};

export default Index;

//_______________________________________________________________________________________________

type PropsItemTree = {
  tree: any;
  getChildren: (id: string) => any[];
  expandedIds: Set<string>;
  toggleExpand: (id: string) => void;
  selectedId: string | null;
  onSelect: (node: any, addMode: boolean) => void;
  setIsAdd: React.Dispatch<React.SetStateAction<boolean>>;
  maxLevel: number;
  searchTokens: string[];
  matchIds: Set<string>;
};

const ItemTree: React.FC<PropsItemTree> = ({
  tree,
  getChildren,
  expandedIds,
  toggleExpand,
  selectedId,
  onSelect,
  setIsAdd,
  maxLevel,
  searchTokens,
  matchIds
}) => {
  const { i18n } = useTranslation();
  const children = getChildren(tree.id);
  const hasChildren = children?.length > 0;

  const isExpanded = expandedIds.has(tree.id) || tree?.accountParant === null;
  const isSelected = selectedId === tree.id;

  const displayText = i18n.language === 'en' ? tree.name : tree.name2;

  return (
    <Fragment key={tree.id}>
      <div className="d-flex justify-content-between p-1 border-1 border-start border-theme">
        <div
          className={[
            'file-node',
            hasChildren ? 'has-sub' : '',
            isExpanded ? 'expand' : '',
            isSelected ? 'selected' : ''
          ].join(' ')}
        >
          <Link to="" className="file-link" onClick={e => e.preventDefault()}>
            <span
              className="file-arrow"
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                if (hasChildren) toggleExpand(tree.id);
              }}
              style={{ cursor: hasChildren ? 'pointer' : 'default' }}
            ></span>

            <span
              className="file-info"
              onClick={e => {
                e.preventDefault();
                onSelect(tree, false);
                setIsAdd(false);
              }}
              style={{ cursor: 'pointer' }}
            >
              <span className="file-icon">
                <i className={`bi ${tree.accountlevel === 1 ? 'bi-diagram-3' : 'bi-wallet2'} fa-lg text-theme`}></i>
              </span>

              <span className={`file-text fw-bold ${matchIds.has(tree.id) ? 'text-theme' : ''}`}>
                {highlightTokens(String(displayText ?? ''), searchTokens)}
              </span>
            </span>
          </Link>

          {isExpanded && hasChildren && (
            <div className="file-tree">
              {children.map((node: any) => (
                <ItemTree
                  key={node.id}
                  tree={node}
                  getChildren={getChildren}
                  expandedIds={expandedIds}
                  toggleExpand={toggleExpand}
                  selectedId={selectedId}
                  onSelect={onSelect}
                  setIsAdd={setIsAdd}
                  maxLevel={maxLevel}
                  searchTokens={searchTokens}
                  matchIds={matchIds}
                />
              ))}
            </div>
          )}
        </div>

        <div>
          <Link
            to=""
            hidden={tree.accountlevel == null || Number(tree.accountlevel) >= Number(maxLevel)}
            className="pt-1 ms-2 text-theme"
            onClick={e => {
              e.preventDefault();
              onSelect(tree, true);
              setIsAdd(true);
            }}
          >
            <i className="fa-lg fa-fw fs-4 bi bi-plus-square-fill"></i>
          </Link>
        </div>
      </div>
    </Fragment>
  );
};